import { useEffect } from 'react';

import { useRouter } from 'next/router';

import { ProductDetailed } from '~/src/common/typings/product';

export const useProductContentRedirect = (product: ProductDetailed | undefined, slug: string) => {
  const { replace, pathname, query } = useRouter();

  useEffect(() => {
    if (product == null) return;
    if (product.slug === slug) return;
    const as = `/produit/${product.slug}`;
    // eslint-disable-next-line @typescript-eslint/no-floating-promises  -- auto-ignored when updating eslint
    replace({ pathname, query: { ...query, slug: product.slug } }, as);
  }, [slug, product, pathname, query, replace]);
};
